<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header">
      <a id="TargetDokumente"></a>
      <h3>
        <i class="icon-drucker"></i><span i18n>Dokumente</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header card-header-detail" i18n>Dokumente</div>

            <div class="card-body">
              <p *ngIf="hasAlreadyCapturedMaxNumOfPages" style="font-weight: bold; color:#ca7d7d" i18n>
                Das Limit von {{ scankomponenteSettings.maxCapturedPages }} eingescannten Seiten ist bereits erreicht.
              </p>
              <p *ngIf="numberOfRemainingABHDocumentsToScan === 0" style="font-weight: bold; color:#ca7d7d" i18n >
                Das Limit von {{ documentSettings.abhMaxNumberOfFiles }} eingescannten ABH-Dokumenten ist bereits erreicht.
              </p>
              <p *ngIf="numberOfRemainingBADocumentsToScan === 0" style="font-weight: bold; color:#ca7d7d" i18n>
                Das Limit von {{ documentSettings.baMaxNumberOfFiles }} eingescannten BA-relevanten Dokumenten ist bereits erreicht.
              </p>
              <p *ngIf="(needsBADocument$ | async) && (form.hasError('missingBADocument') || form.hasError('noDocuments'))" style="font-weight: bold; color:#ca7d7d" i18n>
                Bitte fügen Sie dem Antrag mindestens ein für die Bundesagentur für Arbeit (BA) relevantes Dokument bei.
              </p>

              <div class="row">
                <div class="mb-3 col-md-6">
                  <label for="dokumente.scannen.select" i18n [class.mandatory]="true">Dokumentenbezeichnung</label>
                  <select id="dokumente.scannen.select" formControlName="dokumentart" class="form-select form-control">
                    <option value=""></option>
                    <option *ngFor="let documentType of dokumentartListItems;" value="{{ documentType.fields?.dokumentenname }}">{{ documentType.fields?.dokumentenname }}</option>
                  </select>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12">
                  <button type="button" class="btn btn-primary"
                          id="dokumente.scannen.button"
                          [disabled]="!isButtonEnabledInGUI"
                          (click)="onScanClicked()"
                  ><span i18n>Scannen</span></button>
                </div>
              </div>

              <div class="row mt-4" *ngIf="isDocumentListVisible">
                <div class="col-md-12 table-responsive">
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th i18n>Dokument</th>
                      <th i18n>Größe</th>
                      <th i18n>Aktion</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let pdfDokument of pdfDokumentList; let i = index">
                      <td style="width: 75%;">{{ getDokumentArtDisplayValue(pdfDokument.doctype) }}</td>
                      <td *ngIf="documentService.isBADocument(pdfDokument)" style="width: 75%;"
                          [class.is-invalid]="isDocumentSizeInvalid(pdfDokument)"
                          ngbTooltip="Das eingescannte BA-relevante Dokument überschreitet die zulässige Höchstgrenze von {{(documentSettings.baMaxFileSizeInBytes / 1000).toFixed(0) }} KB. Bitte löschen Sie das Dokument und reduzieren Sie vor dem erneuten Einscannen die Seitenzahl."
                          i18n-ngbTooltip
                          [disableTooltip]="!isDocumentSizeInvalid(pdfDokument)"
                          container=body>
                        {{ (pdfDokument.sizeInBytes / 1000).toFixed(0) }} KB
                      </td>
                      <td *ngIf="!documentService.isBADocument(pdfDokument)" style="width: 75%;"
                          [class.is-invalid]="isDocumentSizeInvalid(pdfDokument)"
                          ngbTooltip="Das eingescannte Dokument überschreitet die zulässige Höchstgrenze von {{(documentSettings.abhMaxFileSizeInBytes / 1000).toFixed(0)}} KB. Bitte löschen Sie das Dokument und reduzieren Sie vor dem erneuten Einscannen die Seitenzahl."
                          i18n-ngbTooltip
                          [disableTooltip]="!isDocumentSizeInvalid(pdfDokument)"
                          container=body>
                        {{ (pdfDokument.sizeInBytes / 1000).toFixed(0) }} KB
                      </td>
                      <td style="display: flex; ">
                         <span (click)="showPdfFromList(i)" style="cursor:pointer; text-decoration: underline; margin-right: 1em;"
                               i18n>Anzeigen</span>
                        <span (click)="removePdfFromList(i)" style="cursor:pointer; text-decoration: underline;" i18n>Entfernen</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #viewPDFDocument let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Anzeigen</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="c({ result: 'cancel' })">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <object *ngIf="viewPdfUrl" [data]="viewPdfUrl" type="application/pdf" style="width:750px;height:700px;">
      <p>PDF zur Anzeige - <a [href]="viewPdfUrl">Download</a></p>
    </object>
  </div>
</ng-template>

<ng-template #errorDialog let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Fehler</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="c({ result: 'cancel' })">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <span i18n>Der Scandialog konnte nicht gestartet werden. Dies kann an den folgenden Ursachen liegen:</span>
    <ul class="mt-3">
      <li i18n>Der benötigte Scandialog ist nicht installiert.</li>
      <li i18n>Der Scandialog wird bereits von einer anderen Anwendung benutzt.</li>
    </ul>
  </div>
</ng-template>

<div [hidden]="!isDialogDisplayed" id="scankomponente-container">
  <div id="scankomponente-button-row">
    <a class="btn" (click)="closeScankomponenteDialog()">
      <span id="scankomponente-close-button" class="icon-cross"></span>
    </a>
  </div>
  <div id="scankomponente-iframe-row">
    <iframe #iframe
            (load)="onFrameLoad()"
            id="scankomponente-iframe"
            title="Scankomponente"
            name="Scankomponente">
      <p>Ihr Browser kann leider keine eingebetteten Frames anzeigen:
        Sie können die eingebettete Seite über den folgenden Verweis aufrufen:
        <a [href]="safeResourceUrl | safeUrl">Scankomponente</a>
      </p>
    </iframe>
  </div>
</div>
